module.exports = __webpack_public_path__ + "img/4.bca1c7b8.jpg";